<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="justify-center">{{ $t('views.auth.register.registration') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-text-field
                    v-model="form.web_app_code"
                    :label="$t('views.auth.register.client_code_label')"
                    :hint="$t('views.auth.register.client_code_hint')"
                    maxlength="10"
                    :error="$store.getters.hasValidationError('web_app_code')"
                    :error-messages="$store.getters.validationError('web_app_code')"
                ></v-text-field>

                <v-text-field
                    v-model="form.email"
                    :label="$t('views.auth.register.email_label')"
                    maxlength="255"
                    :error="$store.getters.hasValidationError('email')"
                    :error-messages="$store.getters.validationError('email')"
                ></v-text-field>

                <v-text-field
                    v-model="form.password"
                    :label="$t('views.auth.register.password_label')"
                    :hint="$t('views.auth.register.password_hint')"
                    maxlength="255"
                    :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordVisible ? 'text' : 'password'"
                    @click:append="passwordVisible = !passwordVisible"
                    :error="$store.getters.hasValidationError('password')"
                    :error-messages="$store.getters.validationError('password')"
                ></v-text-field>

                <v-text-field
                    v-model="form.password_confirmation"
                    :label="$t('views.auth.register.password_confirmation_label')"
                    maxlength="255"
                    :append-icon="passwordConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passwordConfirmVisible ? 'text' : 'password'"
                    @click:append="passwordConfirmVisible = !passwordConfirmVisible"
                ></v-text-field>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn type="submit" color="success" rounded block :loading="registering">
                    {{ $t('views.auth.register.register_button') }}
                </v-btn>
            </v-card-actions>

            <v-card-text class="text-center">
                <router-link :to="{name: 'forgot_password'}">
                    {{ $t('views.auth.register.password_recovery_link') }}
                </router-link>
                |
                <router-link :to="{name: 'login'}">
                    {{ $t('views.auth.register.login_link') }}
                </router-link>
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
import {Auth} from "../../modules/utils";

export default {
        name: "Register",

        data() {
            return {
                passwordVisible: false,
                passwordConfirmVisible: false,
                registering: false,

                form: {
                    web_app_code: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                },
            };
        },

        methods: {
            submit: function() {

                if(this.registering) {
                    return;
                }

                this.registering = true;

                this.$store.dispatch('registerNewUser', this.form)
                    .then(response => {
                        if(response.status !== 201) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.register.registration_failed')
                            );
                            return;
                        }

                        Auth.authenticate();
                        Auth.verify(false);
                        this.$router.push({name: 'orders'}).catch(() => {});
                    })
                    .catch(() => {})
                    .then(() => {
                    this.registering = false;
                });
            },
        },
    }
</script>

<style scoped>

</style>
